import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23b955ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Gráfica", -1))

import { onMounted, ref } from "vue";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import { getPaginatedEstimations } from "@/service/estimation.service";
import { ValidationFilter_2, Estimation } from "@/types/estimation.type";
import { GraphClientFilter } from "@/types/graphClient";
import am5lang_es_ES from "@amcharts/amcharts5/locales/es_ES";
import { getClientData } from "@/service/graphClient.service";
import { AxisRenderer, ValueAxis } from "@amcharts/amcharts5/xy";
import { Parameter } from "@/types/parameter.type";


export default /*#__PURE__*/_defineComponent({
  props: {
    graphClient: null
  },
  setup(__props: any) {

const props = __props as {
  graphClient: GraphClientFilter;
}

const chartdiv = ref<HTMLDivElement | null>(null);



onMounted(async () => {
  handleGraphData(props.graphClient);
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const handleGraphData = (data: any) => {
  renderChart(data);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
async function renderChart(data: any) {
  if (!chartdiv.value) return;

  const root = am5.Root.new(chartdiv.value);
  // Establecer formato gráfica
  root.numberFormatter.set("numberFormat", "####.##");

  const myTheme = am5.Theme.new(root);

  myTheme.rule("AxisLabel", ["minor"]).setAll({
    dy: 1,
  });
  myTheme.rule("Grid", ["x"]).setAll({
    strokeOpacity: 0.05,
  });
  myTheme.rule("Grid", ["x", "minor"]).setAll({
    strokeOpacity: 0.05,
  });
  root.setThemes([am5themes_Animated.new(root), myTheme]);

  // Create chart
  const chart = root.container.children.push(
    am5xy.XYChart.new(root, {
      panX: true,
      panY: true,
      wheelX: "panX",
      wheelY: "zoomX",
      maxTooltipDistance: 0,
      pinchZoomX: true,
    })
  );

  chart.get("colors")?.set("step", 2);

  root.locale = am5lang_es_ES;

  let date = new Date();
  date.setHours(0, 0, 0, 0);
  //let value = 100;

  //Obtener datos estimaciones
  async function getDataChart() {
    const validationFilter = {
      samplingPointId: data.graphClientFilter.samplingPoint?.id,
      parameterId: data.graphClientFilter.parameter?.id,
      date: [
        data.graphClientFilter.startDate?.getTime(),
        data.graphClientFilter.endDate?.getTime(),
      ],
    } as unknown as ValidationFilter_2;

    const estimation_history = await getPaginatedEstimations(validationFilter);

    return estimation_history.map((estimation) => ({
      date: estimation.dateTime ? new Date(estimation.dateTime).getTime() : undefined,
      value: estimation.value,
    }));
  }

  //Obtener client data
  async function getClientDatas() {
    const validationFilterDatas = {
      samplingPointId: data.graphClientFilter.samplingPoint?.id,
      parameterId: data.graphClientFilter.parameterClient?.id,
      date: [data.graphClientFilter.startDate, data.graphClientFilter.endDate],
    } as unknown as ValidationFilter_2;

    const estimation_history = await getClientData(validationFilterDatas);

    return estimation_history.map((estimation: Estimation) => ({
      date: estimation.dateTime ? new Date(estimation.dateTime).getTime() : undefined,
      value: estimation.value,
    }));
  }

  // Create axes
  let xAxis = chart.xAxes.push(
    am5xy.DateAxis.new(root, {
      maxDeviation: 0.2,
      baseInterval: {
        timeUnit: "millisecond",
        count: 1,
      },
      renderer: am5xy.AxisRendererX.new(root, {
        minorGridEnabled: true,
      }),
      tooltip: am5.Tooltip.new(root, {}),
    })
  );

  // Grafica estimaciones

  var yRenderer1 = am5xy.AxisRendererY.new(root, {
    opposite: false,
  });

  let series = chart.series.push(
    am5xy.LineSeries.new(root, {
      name: data.graphClientFilter.parameter.name,
      xAxis: xAxis,
      yAxis: generatedYAxis(root, data.graphClientFilter.parameter, chart, yRenderer1),
      valueYField: "value",
      valueXField: "date",
      tooltip: am5.Tooltip.new(root, {
        pointerOrientation: "horizontal",
        labelText: "",
      }),
    })
  );
  yRenderer1.labels.template.set("fill", am5.color("#00FF00"));
  //- Estilos del eje
  yRenderer1.setAll({
    stroke: am5.color("#00FF00"),
    strokeOpacity: 1,
    opacity: 1,
  });

  //- Cliente

  var yRenderer2 = am5xy.AxisRendererY.new(root, {
    opposite: true,
  });

  let series2 = chart.series.push(
    am5xy.LineSeries.new(root, {
      name: data.graphClientFilter.parameterClient.name,
      xAxis: xAxis,
      yAxis: generatedYAxis(root, data.graphClientFilter.parameterClient, chart, yRenderer2),
      valueYField: "value",
      valueXField: "date",
      tooltip: am5.Tooltip.new(root, {
        pointerOrientation: "horizontal",
        labelText: "{valueY}",
      }),
    })
  );
  yRenderer2.labels.template.set("fill", series2.get("fill"));
  //- Estilos del eje
  yRenderer2.setAll({
    stroke: series2.get("fill"),
    strokeOpacity: 1,
    opacity: 1,
  });

  let dataForSeries2 = await getClientDatas();
  series2.data.setAll(dataForSeries2);
  series2.strokes.template.set("stroke", am5.color("#0000FF"));
  series2.bullets.push(() => {
    return am5.Bullet.new(root, {
      sprite: am5.Circle.new(root, {
        radius: 2,
        fill: series2.get("fill"),
        strokeWidth: 2,
        tooltipText: "{valueX.formatDate('dd/MM/yyyy HH:mm:ss')}",
        showTooltipOn: "hover",
        tooltip: am5.Tooltip.new(root, {}),
        cursorOverStyle: "ns-resize",
      }),
    });
  });
  series2.appear();

  let dataForSeries1 = await getDataChart();
  series.data.setAll(dataForSeries1);
  series.strokes.template.set("stroke", am5.color("#00FF00"));
  series.appear();

  // Add scrollbar
  chart.set(
    "scrollbarX",
    am5.Scrollbar.new(root, {
      orientation: "horizontal",
    })
  );

  chart.set(
    "scrollbarY",
    am5.Scrollbar.new(root, {
      orientation: "vertical",
    })
  );

  const legend = chart.children.push(
    am5.Legend.new(root, {
      x: am5.percent(50),
      y: am5.percent(98),
      centerX: am5.percent(50),
      layout: am5.GridLayout.new(root, {
        maxColumns: 2,
        fixedWidthGrid: true,
      }),
    })
  );

  legend.valueLabels.template.setAll({
    width: am5.p100,
    textAlign: "center",
  });

  legend.data.setAll(chart.series.values);

  chart.appear(1000, 100);
}

function generatedYAxis(
  root: am5.Root,
  parameter: Parameter,
  chart: am5xy.XYChart,
  renderer: am5xy.AxisRendererY
) {
  let yAxis: ValueAxis<AxisRenderer>;
  if (
    (parameter.code && (parameter.code === "TMOA" || parameter.code === "NIV")) ||
    (parameter.physicalRange &&
      parameter.physicalRange[0] === 0 &&
      parameter.physicalRange[1] === 1)
  ) {
    yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        maxPrecision: 0,
        renderer: renderer,
      })
    );
  } else {
    yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        renderer: renderer,
      })
    );
  }

  return yAxis;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", {
      ref_key: "chartdiv",
      ref: chartdiv,
      class: "chart-container",
      style: {"width":"100%","height":"52vh"}
    }, null, 512)
  ], 64))
}
}

})